import { render } from "./chatRoom.vue?vue&type=template&id=ad9ae832"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"

import "./chatRoom.vue?vue&type=style&index=0&id=ad9ae832&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__